<template>
    <div class="auth-base">
        <slot />
        <img class="qfact-logo-bottom" src="/statics/img/Qfact-logo.svg" alt="" />
        <notifications />
    </div>
</template>

<script>
import Notifications from '@/components/Notifications';

export default {
    name: 'AuthBase',
    components: {
        Notifications
    }
};
</script>

<style>
.auth-base {
    display: grid;
    place-items: center;
    min-height: 100dvh;
}

.qfact-logo-bottom {
    position: fixed;
    bottom: 48px;
    height: 40px;
    z-index: -1;
}
</style>
